import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { PostLikesModalComponent } from "./PostLikesModalComponent";
import { PostLikesModalUIKitComponent } from "./PostLikesModalUIKitComponent";

type PostLikesModalUIKitComponentProps = ComponentPropsWithoutRef<
  typeof PostLikesModalUIKitComponent
>;

const PostLikesModalUIKit = ModalManager.create(
  (props: PostLikesModalUIKitComponentProps) => (
    <PostLikesModalUIKitComponent {...props} />
  ),
);

type PostLikesModalComponentProps = Omit<
  ComponentPropsWithoutRef<typeof PostLikesModalComponent>,
  "open" | "onOpenChange" | "onOpenChangeComplete"
>;

const PostLikesModal = ModalManager.create(
  (props: PostLikesModalComponentProps) => {
    const modal = useModal();

    return (
      <PostLikesModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            void modal.hide();
          }
        }}
        onOpenChangeComplete={open => {
          if (!open) {
            modal.remove();
          }
        }}
      />
    );
  },
);

export const usePostLikesModal = () => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");
  const ModalComponent = isCircleV4 ? PostLikesModal : PostLikesModalUIKit;

  return useModal(ModalComponent);
};
